import React, { useState } from "react";

function ContactSection({
  phoneNumber,
  onPhoneNumberChange,
  onPhoneNumberNormalize,
  isPhonePublic = false,
  onIsPhonePublicChange,
}) {
  const [isHintOpen, setIsHintOpen] = useState(false);

  const toggleHint = () => setIsHintOpen((prev) => !prev);

  return (
    <section
      className="ap-pane"
      aria-labelledby="ep-pane-contact"
      data-section="contact"
    >
      <header className="ap-pane__head">
        <h2 id="ep-pane-contact">
          <i className="fa-solid fa-phone" aria-hidden="true"></i>Контакти
        </h2>
        <p>Номер телефону використовується для зв'язку клієнтів з вами.</p>
      </header>

      <div className="ap-row">
        <div className="ap-field ap-field--wide">
          <div className="d-flex align-items-center gap-2">
            <label htmlFor="phone-number" className="mb-0">
              Номер телефону <span className="req" aria-hidden="true">*</span>
            </label>
            <button
              type="button"
              className={`exclamation-btn${isHintOpen ? "" : " collapsed"}`}
              data-disclosure-trigger="phone-format-hint"
              aria-expanded={isHintOpen}
              aria-controls="phone-format-hint"
              aria-label="Підказка про формат номера"
              onClick={toggleHint}
            >
              <i className="fa-solid fa-exclamation" aria-hidden="true"></i>
            </button>
          </div>
          <input
            type="tel"
            className="form-control"
            id="phone-number"
            name="phone_number"
            data-field="phone_number"
            autoComplete="tel"
            inputMode="tel"
            pattern="\+380\d{9}"
            minLength="13"
            maxLength="13"
            aria-describedby="phone-hint"
            required
            value={phoneNumber}
            onChange={(e) => onPhoneNumberChange(e.target.value)}
            onFocus={onPhoneNumberNormalize}
            onBlur={onPhoneNumberNormalize}
          />
          <small id="phone-hint" className="form-hint">
            Формат: +380XXXXXXXXX (13 символів).
          </small>
        </div>
      </div>

      <div className="ap-row">
        <div className="ap-field ap-field--wide">
          <div className="form-check">
            <input
              type="checkbox"
              className="form-check-input"
              id="is-phone-public"
              name="is_phone_public"
              data-field="is_phone_public"
              checked={Boolean(isPhonePublic)}
              onChange={(e) => onIsPhonePublicChange?.(e.target.checked)}
            />
            <label className="form-check-label" htmlFor="is-phone-public">
              Показувати номер телефону іншим користувачам
            </label>
          </div>
          <small className="form-hint" id="phone-public-hint">
            Якщо увімкнено, номер може з&apos;явитися у публічному профілі та на
            сторінках ваших оголошень.
          </small>
        </div>
      </div>

      <div
        className={`collapse question-area${isHintOpen ? " show" : ""}`}
        id="phone-format-hint"
        data-disclosure-panel="phone-format-hint"
      >
        <div className="card card-body">
          Обов&apos;язково починати номер телефону з <strong>+380</strong>, інакше кнопка номера телефону на сайті
          може не бути робочою!
        </div>
      </div>
    </section>
  );
}

export default ContactSection;
